import React from 'react';
import { observer } from 'mobx-react-lite';
import { TeamSettingsPageState } from '../../pages/teamSettingsPage/teamSettingsPageState';
import { FilterFieldButton } from '../input';
import { MenuItem } from '../input/menuItems';
import { TeamMemberRole } from '@clipr/lib';
import { SortButton } from './sortButton';

type Props = {
  model: TeamSettingsPageState;
};

export const TeamMembersHeader = observer(({ model }: Props) => {
  const { teamMemberCatalogSource } = model;

  const filterByRoleValue = teamMemberCatalogSource.getFilterFieldValue('role');

  return (
    <div className="team-members-catalog-header catalog-filters">
      <table className="team-members-header team-members-core">
        <thead>
          <tr>
            <th className="name-col">
              <SortButton label="Full Name" sortField="name" model={model} />
            </th>

            <th className="username-col">
              <SortButton
                label="Username"
                sortField="username"
                model={model}
              />
            </th>

            <th className="email-col">
              <SortButton label="Email" sortField="email" model={model} />
            </th>

            <th className="role-col">
              <FilterFieldButton
                label={
                  filterByRoleValue ?
                    filterByRoleValue :
                    'Role'
                }
                selected={
                  !!filterByRoleValue
                }>
                {Object.values(TeamMemberRole).map((type) => (
                  <MenuItem
                    key={type}
                    model={{ value: type, label: type }}
                    onClick={() =>
                      teamMemberCatalogSource.setFilterFieldValue('role', type)
                    }
                    isSelected={
                      filterByRoleValue === type
                    }
                  />
                ))}
              </FilterFieldButton>
            </th>

            <th className="analytics-col">
              <p>Exclude from Analytics</p>
            </th>
          </tr>
        </thead>
      </table>
    </div>
  );
});